import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/ClientBranches.css";

function ClientBranches() {
  const navigate = useNavigate();

  const stateCards = [
    {
      name: "Daman",
      image: "/locations/daman.png",
      path: "/clients/daman",
    },
    {
      name: "Maharashtra",
      image: "/locations/Indian-gate.png",
      path: "/clients/maharashtra",
    },
    {
      name: "Gujarat",
      image: "/locations/statue.png",
      path: "/clients/gujarat",
    },
    {
      name: "Andhra Pradesh",
      image: "/locations/tirupati.png",
      path: "/clients/andhra-pradesh",
    },
    {
      name: "Telangana",
      image: "/locations/charminar.png",
      path: "/clients/telangana",
    },
  ];

  const handleCardClick = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
  };

  return (
    <div className="client-branches-container">
      <div className="client-branches-header">
        <h2 className="client-branches-title">
          Industrial Catering Across India
        </h2>
        <p className="client-branches-description">
          We proudly serve across India, from industrial cities like Mumbai,
          Kolhapur, and Daman to southern regions like Anantapur. Our services are
          customized for every client—be it large-scale manufacturing units,
          energy sites fully customized according to the client requirements.
        </p>
      </div>

      <div className="client-branches-grid">
        {stateCards.map((state, index) => (
          <div
            className="client-branch-card"
            key={index}
            onClick={() => handleCardClick(state.path)}
          >
            <img
              src={state.image}
              alt={state.name}
              className="client-branch-image"
            />
            <span className="client-branch-label">{state.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ClientBranches;
